import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import './i18n/config';

datadogRum.init({
    applicationId: '830fa9d3-f0ea-4821-8f8e-eb7128edbf2c',
    clientToken: 'pub62d6fd13bbba664eedc115ef46dbf9ba',
    site: 'datadoghq.com',
    service:'rent-ui',
    env: 'prod',

    allowedTracingUrls: [
      "https://loyer.celestos.fr",
      // Matches any subdomain of my-api-domain.com, such as https://foo.my-api-domain.com
      /^https:\/\/[^/]+\.celestos\.fr/,
      // You can also use a function for advanced matching:
      (url: string) => url.startsWith("https://loyer.celestos.fr")
    ],
    
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate:  100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
});


const root = document.getElementById('root')
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);